import React, {useEffect} from 'react';
import Campus_Ambassador_discuraption from './Campus_Ambassador_discuraption'
import CA_second_comp from './CA_second_comp'
import CA_third_comp from './CA_third_comp'
import CA_forth_comp from './CA_forth_comp'
import CA_total_Count from './CA_total_count';

function Campus_Ambassador() {
  useEffect(()=>{
    document.title= 'Campus Ambassador | InternsElite';
  },[]);
  return (
    <>
    <div>
    {/* ------------------------Mobile View------------------------------ */}
      <div className='Mobile_CA_background_image d-sm-block d-md-none mt-5'>
        <div className='container-fluid Mobile_CA_background_color pt-4'>
            <div className='text-center mobile_CA_Main_text'>
                <h1 className='display-6 pt-5 text-white'>InternsElite's Campus Ambassador</h1>
                <h3 className='text-white pt-2 pb-5'>Be the Campus Trendsetter with InternsElite!</h3>
            </div>
        </div>
        </div>
    
    {/* ------------------------Desktop View------------------------------ */}
        <div className='CA_background_image d-none d-md-block mt-5'>
        <div className='container-fluid CA_background_color pt-5'>
            <div className='text-center pt-5 About_Main_text mt-5'>
                <h1 className='display-4 pt-5 mt-5 text-white'>InternsElite's Campus Ambassador</h1>
                <h3 className='text-white fs-2 pt-3 '>Be the Campus Trendsetter with InternsElite!</h3>
            </div>
        </div>
        </div>
    </div>
    <div><Campus_Ambassador_discuraption/></div>
    <div><CA_second_comp/></div>
    <div className='Roadmap_background'><div className='container pb-5'><CA_third_comp/></div></div>
    <div className='pt-5 pb-4'><CA_forth_comp/></div>
    <div><CA_total_Count/></div>
  </>
  )
}

export default Campus_Ambassador
